module.exports = __webpack_public_path__ + "assets/media/lunch.55bb19f2.mp3";